<div class="full-content-scroll">
  <form #form="ngForm">
    @if (terminal) {
      <div>
        <div class="input-group cursor-default" style="margin-left: 10px; padding-top: 20px; width: calc(100% - 10px); display: block;">
          <div class="controls">
            <mat-form-field [class.edit]="isEditMode" [floatLabel]="'always'" style="width: 16rem; margin-left: 10px;" class="middle-height">
              <mat-label>Typ</mat-label>
              <input matInput [(ngModel)]="terminal.deviceType" id="Typ" name="Typ" [matAutocomplete]="auto"
                [readonly]="!isEditMode || !canEditSerialNumberAndType"
                [required]="isEditMode" type="text" #type="ngModel" />
                <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
                  @for (deviceType of filteredDeviceTypes | async; track deviceType) {
                    <mat-option [value]="deviceType">
                      {{deviceType}}
                    </mat-option>
                  }
                </mat-autocomplete>
              </mat-form-field>
              <error-icon [show]="showError && type.invalid" [form]="form" [controlName]="'Typ'"></error-icon>
              <status [status]="terminal.status"></status>
              <!-- Service Modus -->
              @if (isOnline) {
                <button mat-icon-button ngbTooltip="Service Modus aktivieren" container="body" tooltipClass="myTooltip" (click)="setServiceMode(terminal)"
                  style="margin-top: -10px;" [disabled]="deactivateServiceModeButton">
                  <mat-icon>settings</mat-icon>
                </button>
              }
            </div>
            <div class="controls">
              <mat-form-field [class.edit]="isEditMode" [floatLabel]="'always'" style="width: 16rem; margin-left: 10px;" class="middle-height">
                <mat-label>Seriennummer</mat-label>
                <input matInput [(ngModel)]="terminal.serialNumber" id="Seriennummer" name="Seriennummer"
                  [readonly]="!isEditMode || !canEditSerialNumberAndType"
                  [required]="isEditMode" type="text" #serialNumber="ngModel" />
                </mat-form-field>
                <error-icon [show]="showError && serialNumber.invalid" [form]="form" [controlName]="'Seriennummer'"></error-icon>
              </div>
              <div class="controls">
                <mat-form-field [class.edit]="isEditMode" [floatLabel]="'always'" style="width: 16rem; margin-left: 10px;" class="middle-height">
                  <mat-label>Name</mat-label>
                  <input matInput [(ngModel)]="terminal.name" id="Name" name="Name" [readonly]="!isEditMode" type="text" #name="ngModel" />
                </mat-form-field>
                <!--<error-icon [show]="showError && name.invalid" [form]="form" [controlName]="'Name'"></error-icon>-->
              </div>
              <div class="controls">
                @if (anyShopAvailable) {
                  <mat-form-field [class.edit]="isEditMode" [floatLabel]="'always'" style="width: 16rem; margin-left: 10px;" class="middle-height">
                    <mat-label>
                      Betriebsstätte
                    </mat-label>
                    <div class="BetriebsstaetteMatSelect">
                      <mat-select [disabled]="!isEditMode" [compareWith]="compareFn"
                        name="shop" [(ngModel)]="terminal.shop" (selectionChange)="terminal.shop = $event.value">
                        @for (shop of allShops; track trackByFn($index, shop)) {
                          <mat-option [value]="shop">
                            {{shop.name}}
                          </mat-option>
                        }
                      </mat-select>
                    </div>
                  </mat-form-field>
                }
                @if (!anyShopAvailable) {
                  <span class="alert alert-warning" role="alert">Leider gibt es keine Betriebsstätte zur Auswahl!</span>
                }
              </div>
            </div>
          </div>
        }
      </form>
    </div>
